import styled from 'styled-components'
import { Select as AntSelect } from 'antd'
import { theme, media } from '../../../../../../styles/_variables'


export const SelectBoxContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  padding: 4px 15px 4px 15px;
  background-color: ${theme.color.greenPrimary};
  border-radius: 5px;
  box-shadow: ${props => (props.center ? '0px;' : '2px 2px 0px 1px rgb(110, 201, 190, 0.4) !important;')}
`

export const Select = styled(AntSelect)`
  width: ${props => (props.center ? '40%;' : '100%;')}
  margin-left: ${props => (props.center ? '40px;' : '0px;')}
  ${media.mobileL`
    width: ${props => (props.center ? '45%;' : '100%;')}
    margin-left: ${props => (props.center ? '12px;' : '0px;')}
  `}
  .ant-select-selection {
    border-radius: 5px;
    border: 1px solid #EFFFFE !important;
    background-color: #EFFFFE !important;
    color: ${theme.color.greyNormal};
    padding: 2px 0px;
  }
  .ant-select-selection__rendered {
    text-align: center;
  }
  .ant-select-selection__placeholder {
    font-size: ${theme.fonts.size.normal};
    font-weight: ${theme.fonts.style.medium};
    text-align: center;
  }
  .ant-select-selection-selected-value {
    color: ${theme.color.greyNormal};
    font-size: ${theme.fonts.size.normal};
    font-weight: ${props => (props.thin ? theme.fonts.style.light : theme.fonts.style.medium)};
    text-align: center;
    width: 100%;
    margin-top: -4px;
  }
  .ant-select-arrow {
    color: rgba(${theme.color.primaryColorRGB}, 1);
    top: 40% !important;
    opacity: 0.6;
  }

`

export const Title = styled.p`
  width: ${props => (props.center ? 'fit-content;' : '100%;')}
  font-size: ${theme.fonts.size.extraNormal};
  font-weight: ${theme.fonts.style.medium};
  color: ${theme.color.offWhite}
  margin-bottom: 0;
  text-align: ${props => (props.center && 'right')};
  ${media.mobileL`
    font-size: ${theme.fonts.size.normal};
  `}
  ${media.mobileM`
    font-size: ${theme.fonts.size.small};
  `}
`
export default Select



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/common/select-box/styled.js